import "overlayscrollbars/overlayscrollbars.css";
import "./styles/globals.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { setupHardRefreshReset } from "./lib/hardRefreshReset";
import { routeTree } from "./routeTree.gen";

document.documentElement.setAttribute("data-overlayscrollbars-initialize", "");
document.body.setAttribute("data-overlayscrollbars-initialize", "");

setupHardRefreshReset();

let cachedQueryClient: QueryClient | undefined;
const getQueryClient = () => {
  if (!cachedQueryClient) {
    cachedQueryClient = new QueryClient();
  }
  return cachedQueryClient;
};

const queryClient = getQueryClient();

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  context: { queryClient },
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("root element not found");

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
